define('OutSystems/ClientRuntime/modules/Database/IndexedDB/IndexedDBEntityService',["require", "exports", "tslib", "../../../DataTypes", "../../../Exceptions", "../../../Logger", "../AutoNumber", "../Common/EntityService", "../Metadata/MetadataTableInfo", "../TableInfoUtils", "./IndexedDBSerializer", "./Upgrader/IndexedDBMetadataV2Upgrader"], function (require, exports, tslib_1, DataTypes_1, Exceptions_1, Logger, AutoNumber_1, EntityService_1, MetadataTableInfo_1, TableInfoUtils, IndexedDBSerializer_1, IndexedDBMetadataV2Upgrader_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var IndexedDBEntityService = (function (_super) {
        tslib_1.__extends(IndexedDBEntityService, _super);
        function IndexedDBEntityService() {
            return _super.call(this, new IndexedDBSerializer_1.default()) || this;
        }
        IndexedDBEntityService.prototype.executeAggregate = function (body, affectedTables) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var database;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.getDatabase()];
                        case 1:
                            database = _a.sent();
                            try {
                                return [2, database.executeQuery(body, true, affectedTables)];
                            }
                            catch (error) {
                                throw new Exceptions_1.Exceptions.DataBaseException("", error.message, error.stack);
                            }
                            return [2];
                    }
                });
            });
        };
        IndexedDBEntityService.prototype.innerCreate = function (transaction, info, record) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var metaDataRecord, pkAttr, dbRecord, identifier;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, transaction.getRecord(MetadataTableInfo_1.default, [
                                info.key,
                                info.moduleKey,
                            ])];
                        case 1:
                            metaDataRecord = (_a.sent());
                            if (!metaDataRecord) {
                                throw new Error("Unable to create a new record because " + info.name + " wasn't found in metadata table.");
                            }
                            pkAttr = TableInfoUtils.getIdentifierAttribute(info, record);
                            dbRecord = record.clone();
                            if (!(info.idIsAutoNumber === AutoNumber_1.default.YesIfEmpty)) return [3, 3];
                            identifier = this.getRecordIdentifier(metaDataRecord, info, record);
                            dbRecord[pkAttr.attrName] = identifier;
                            return [4, transaction.updateRecord(MetadataTableInfo_1.default, metaDataRecord)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [4, transaction.insertRecord(info, this.serializer.serialize(dbRecord, info))];
                        case 4:
                            _a.sent();
                            if (!pkAttr) {
                                return [2, null];
                            }
                            return [2, dbRecord[pkAttr.attrName]];
                    }
                });
            });
        };
        IndexedDBEntityService.prototype.getRecordIdentifier = function (metaDataRecord, info, record) {
            var pkCol = TableInfoUtils.getIdentifierColumn(info);
            var pkAttr = TableInfoUtils.getIdentifierAttribute(info, record);
            var identifierValue = TableInfoUtils.getIdentifierValue(info, record);
            if (info.idIsAutoNumber === AutoNumber_1.default.YesIfEmpty) {
                var lastRecordId = metaDataRecord.LASTIDENTIFIER !== undefined
                    ? this.serializer.deserialize(metaDataRecord.LASTIDENTIFIER, pkCol)
                    : DataTypes_1.defaultForType(pkAttr.dataType);
                if (DataTypes_1.equals(identifierValue, DataTypes_1.defaultForType(pkAttr.dataType))) {
                    if (lastRecordId instanceof DataTypes_1.LongInteger) {
                        lastRecordId = lastRecordId.add(1);
                    }
                    else if (typeof lastRecordId === "number") {
                        lastRecordId = lastRecordId + 1;
                    }
                    identifierValue = lastRecordId;
                    metaDataRecord.LASTIDENTIFIER = this.serializer.serialize(identifierValue, pkCol);
                }
                else if (DataTypes_1.compare(identifierValue, lastRecordId) > 0) {
                    metaDataRecord.LASTIDENTIFIER = this.serializer.serialize(identifierValue, pkCol);
                }
            }
            return identifierValue;
        };
        IndexedDBEntityService.prototype.innerCreateOrUpdate = function (tx, info, record) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var recordId, pkCol;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!TableInfoUtils.hasNullIdentifier(info, record)) return [3, 2];
                            return [4, this.innerCreate(tx, info, record)];
                        case 1: return [2, _a.sent()];
                        case 2: return [4, tx.upsertRecord(info, this.serializer.serialize(record, info))];
                        case 3:
                            recordId = _a.sent();
                            pkCol = TableInfoUtils.getIdentifierColumn(info);
                            if (!pkCol) {
                                return [2, null];
                            }
                            return [2, this.serializer.deserialize(recordId, pkCol)];
                    }
                });
            });
        };
        IndexedDBEntityService.prototype.innerCreateOrUpdateAll = function (transaction, info, records) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var metaDataRecord, pkAttr, serializedRecords;
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, transaction.getRecord(MetadataTableInfo_1.default, [
                                info.key,
                                info.moduleKey,
                            ])];
                        case 1:
                            metaDataRecord = (_a.sent());
                            serializedRecords = records.map(function (record) {
                                pkAttr = pkAttr !== null && pkAttr !== void 0 ? pkAttr : TableInfoUtils.getIdentifierAttribute(info, record);
                                var dbRecord = record.clone();
                                if (info.idIsAutoNumber === AutoNumber_1.default.YesIfEmpty) {
                                    var newRecordId = _this.getRecordIdentifier(metaDataRecord, info, record);
                                    dbRecord[pkAttr.attrName] = newRecordId;
                                }
                                return _this.serializer.serialize(dbRecord, info);
                            });
                            if (!(metaDataRecord.LASTIDENTIFIER !== undefined)) return [3, 3];
                            return [4, transaction.updateRecord(MetadataTableInfo_1.default, metaDataRecord)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2, transaction.upsertAllRecords(info, serializedRecords)];
                    }
                });
            });
        };
        IndexedDBEntityService.prototype.registerInitializer = function (entityInfos) {
            _super.prototype.registerInitializer.call(this, entityInfos);
            if (entityInfos && entityInfos.length > 0) {
                Logger.trace(this, "Registering V2 upgrader for entities of module '" + entityInfos[0].moduleKey + "'.");
                var initializer = new IndexedDBMetadataV2Upgrader_1.default(entityInfos, this.serializer);
                this.database.registerInitializer(initializer);
            }
        };
        return IndexedDBEntityService;
    }(EntityService_1.default));
    exports.default = IndexedDBEntityService;
});
//# sourceMappingURL=IndexedDBEntityService.js.map;
